/* eslint-disable */

import modal from './vendors/modal.js';

export default () => {
    if (document.querySelector('[data-target="exit-modal"]') !== null) {
        //Transfers trigger's href to continue link's href
        document.querySelectorAll('[data-target="exit-modal"]').forEach((anchor) => {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();
                const targetUrl = e.target.href;
                document.querySelector('#exit-modal a.modal__continue').href = targetUrl;
            });
        });

        //Closes modal on continue
        document.querySelector('#exit-modal a.modal__continue').addEventListener('click', () => {
            modal.close();
        });
    }
    if (document.querySelector('[data-target="btod-modal"]') !== null) {
        //Transfers trigger's href to continue link's href
        document.querySelectorAll('[data-target="btod-modal"]').forEach((anchor) => {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();
                const targetUrl = e.target.href;
                document.querySelector('#btod-modal a.modal__continue').href = targetUrl;
            });
        });

        //Closes modal on continue
        document.querySelector('#btod-modal a.modal__continue').addEventListener('click', () => {
            modal.close();
        });
    }
};
